const calendar = {
  title: "Übersicht {{date}}",
  today: "Heute",
  noAppointments: "Keine anstehenden Termine",
  calendarHeader: "Kalenderkopf",
  weekCalendarHeader: "Wochenkalender-Kopf",
  previousDay: "Vorheriger Tag",
  nextDay: "Nächster Tag",
  previousWeek: "Vorherige Woche",
  nextWeek: "Nächste Woche",
  selectUser: "Benutzer auswählen",
  openAppointmentView: "Terminübersicht öffnen",
  appointmentOverviewTitle: "Terminübersicht KW {{week}}/{{year}}",
  createAppointment: "Termin erstellen",
  appointmentCreation: {
    title: "Neuen Kalendereintrag erstellen",
    submitButton: "Kalendereintrag erstellen",
    successMessage: "Kalendereintrag wurde erfolgreich erstellt.",
    isAllDay: "Ganztägig",
    startDate: "Datum von",
    startTime: "Uhrzeit von",
    endDate: "Datum bis",
    endTime: "Uhrzeit bis",
    purposeName: "Zweck",
    location: "Ort",
    details: "Details",
    counselor: "Berater:in",
    substitute: "Vertretung",
    showAs: "Anzeigen als",
    endBeforeStart: "Enddatum/-uhrzeit muss nach dem Startdatum/-uhrzeit liegen",
    purposeStatus: {
      categoryAppointment: "Terminplanung",
      categoryAttendance: "Anwesenheitsplanung",
      bookable: "Buchbar",
      notBookable: "Nicht buchbar",
    },
  },
  allDayDays_one: "{{count}} Tag",
  allDayDays_other: "{{count}} Tage",
  appointmentChip: {
    free: "FREI",
    occupied: "BELEGT",
  },
  appointmentClient: {
    notifyTitle: "Benachrichtigung an Kund:in",
    notifyCancellationTitle: "Benachrichtigung über Absage an Kund:in",
    bySms: "Per SMS",
    byEmail: "Per E-Mail",
    noEmail: "Keine E-Mail vorhanden",
    noEmailTooltip: "Für diese Kund:in ist keine E-Mail-Adresse hinterlegt.",
    noPhone: "Keine Telefonnummer vorhanden",
    noPhoneTooltip: "Für diese Kund:in ist keine Telefonnummer hinterlegt.",
    openClientFileInNewTab: "Kundenakt in neuem Tab öffnen",
    markForRemoval: "Kund:in vom Termin entfernen",
    undoRemoval: "Rückgängig",
    removalHint: "Wird beim Speichern entfernt — der Termin ist danach wieder frei.",
    removeConfirmTitle: "Kund:in vom Termin entfernen",
    removeConfirmText:
      "{{name}} wird vom Termin entfernt, der Termin ist danach wieder frei buchbar. Die Kund:in wird über die Absage benachrichtigt.",
    removeConfirmAgree: "Entfernen und speichern",
  },
  attendanceLabel: {
    substitute: "Vertretung: {{userCode}}",
    timeRange: "{{from}}-{{to}} Uhr",
  },
  planAttendance: {
    buttonLabel: "Anwesenheit planen",
    title: "Anwesenheit planen",
    planningMode: "Planungsmodus",
    planningModeWeekly: "Wochenplanung",
    planningModeWeeklySeries: "Wochenserie",
    planningModeMultiDay: "Mehrtägig",
    addEntry: "Eintrag hinzufügen",
    purpose: "Zweck",
    timeFrom: "Uhrzeit von",
    timeTo: "Uhrzeit bis",
    note: "Notiz",
    substitute: "Vertretung",
    successMessage: "Anwesenheitsplan wurde erfolgreich gespeichert.",
    endBeforeStart: "Uhrzeit bis muss nach Uhrzeit von liegen",
    dateFrom: "Datum von",
    dateTo: "Datum bis",
    dateToBeforeFrom: "Datum bis muss nach Datum von liegen",
    seriesConflictTitle: "Bestehende Einträge überschreiben?",
    seriesConflictText: "Im ausgewählten Zeitraum sind bereits Einträge vorhanden. Möchten Sie diese überschreiben?",
    emptyWeekError: "Es muss mindestens ein gültiger Eintrag vorhanden sein.",
    multiDayConfirmTitle: "Planung speichern?",
    multiDayConfirmAgree: "Wochenplanung speichern",
    multiDayConfirmTextBefore: "Im Zeitraum ",
    multiDayConfirmTextBetween: " bis ",
    multiDayConfirmTextAfter:
      " werden alle Tage wie in der angegebenen Wochen gespeichert. Bereits eingetragenen Planungen werden überschrieben.",
  },
  appointmentEdit: {
    title: "Kalendereintrag bearbeiten",
    submitButton: "Kalendereintrag bearbeiten",
    successMessage: "Kalendereintrag wurde erfolgreich aktualisiert.",
    deleteButton: "Kalendereintrag löschen",
    deleteConfirmTitle: "Kalendereintrag löschen",
    deleteConfirmText: "Soll der Kalendereintrag wirklich gelöscht werden?",
    deleteConfirmTextWithClient:
      "Diesem Termin ist {{name}} zugewiesen. Der Kalendereintrag wird gelöscht und die Kund:in über die Absage benachrichtigt.",
    deleteSuccessMessage: "Kalendereintrag wurde erfolgreich gelöscht.",
  },
  journalSupport: {
    activeCount_one: "Aktuell ist {{count}} <bold>Kolleg:in</bold> als Unterstützung aktiv",
    activeCount_other: "Aktuell sind {{count}} <bold>Kolleg:innen</bold> als Unterstützung aktiv",
    activeCountZero: "Aktuell sind keine <bold>Kolleg:innen</bold> als Unterstützung aktiv",
    registerTitle: "Unterstützung Journaldienst",
    registerDescription:
      "Deine Daten sind bereits vorausgefüllt. Setze die Uhrzeit, bis zu der du als Unterstützung zur Verfügung stehst.",
    editTitle: "Unterstützung bearbeiten",
    editDescription: "Zeit anpassen oder Unterstützung vorläufig beenden.",
    statusActive: "aktiv",
    userCodeLabel: "User-Kürzel",
    nameLabel: "Name",
    fromLabel: "Von",
    toLabel: "Bis",
    fromHelper: "Startzeit deiner Unterstützung",
    toHelperCreate: "Geplantes Ende (anpassbar)",
    toHelperEdit: "Geplantes Ende – jederzeit anpassbar",
    endNowWarning:
      'setzt das „Bis" automatisch auf die aktuelle Uhrzeit ({{time}}) und markiert den Eintrag als beendet.',
    endNowButton: "Vorläufig beenden",
    submit: "Speichern",
    successRegister: "Unterstützung wurde erfolgreich registriert.",
    successUpdate: "Unterstützung wurde aktualisiert.",
    successEnd: "Unterstützung wurde beendet.",
    validation: {
      endBeforeStart: '„Bis" muss nach „Von" liegen',
      endAfterMaximum: '„Bis" darf maximal 15:30 sein',
    },
  },
  assign1b: {
    title: "1B Termin für {{firstName}} {{lastName}} auswählen",
    subtitle_one: "{{count}} Termin verfügbar ab {{from}} bis {{to}}",
    subtitle_other: "{{count}} Termine verfügbar ab {{from}} bis {{to}}",
    subtitleEmpty: "Keine Termine verfügbar",
    filters: {
      date: "Datum wählen",
      location: "Ort",
      locationAll: "Alle Orte",
      kzz: "KZZ",
      kzzAll: "Alle KZZ",
    },
    columns: {
      date: "Datum",
      time: "Uhrzeit",
      purpose: "Zweck",
      location: "Ort",
      kzz: "KZZ",
    },
    selectAppointment: "Termin auswählen",
    timeSuffix: "Uhr",
    emptyList: "Keine freien Termine entsprechen den Filtern.",
    loading: "Termine werden geladen",
    cancel: "Abbrechen",
    skip: "Überspringen",
    save: "Speichern",
    successMessage: "Termin wurde erfolgreich zugewiesen.",
  },
};

export default calendar;
